export const CalenderSparkle = ({
  backgroundColor = "#F5F5F5",
  className,
  color = "black",
}: {
  backgroundColor?: string;
  className?: string;
  color?: string;
}) => {
  return (
    <svg
      className={className}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2812 3.4502C16.2867 3.4502 17.1375 4.30098 17.1375 5.30645V8.4002H29.5125V5.30645C29.5125 4.30098 30.3633 3.4502 31.3687 3.4502C32.3742 3.4502 33.225 4.30098 33.225 5.30645V8.4002H35.7C38.407 8.4002 40.65 10.6432 40.65 13.3502V35.6252C40.65 38.3322 38.407 40.5752 35.7 40.5752H10.95C8.24297 40.5752 6 38.3322 6 35.6252V13.3502C6 10.6432 8.24297 8.4002 10.95 8.4002H13.425V5.30645C13.425 4.30098 14.2758 3.4502 15.2812 3.4502ZM10.95 12.1127C10.2539 12.1127 9.7125 12.6541 9.7125 13.3502V17.0627H36.9375V13.3502C36.9375 12.6541 36.3961 12.1127 35.7 12.1127H10.95ZM9.7125 20.7752V35.6252C9.7125 36.3213 10.2539 36.8627 10.95 36.8627H35.7C36.3961 36.8627 36.9375 36.3213 36.9375 35.6252V20.7752H9.7125Z"
        fill={color}
      />
      <rect x="26" y="26.1001" width="20" height="23" fill={backgroundColor} />
      <path
        d="M39.9883 28.5376L42.5234 35.3267L49.3125 37.9048C49.7422 38.0337 50 38.4204 50 38.8501C50 39.2798 49.7422 39.6665 49.3555 39.7954L42.5234 42.3735L39.9883 49.1626C39.8164 49.5923 39.4297 49.8501 39 49.8501C38.5703 49.8501 38.1836 49.5923 38.0547 49.2056L35.4766 42.3735L28.6875 39.8384C28.2578 39.6665 28 39.2798 28 38.8501C28 38.4204 28.2578 38.0337 28.6875 37.9048L35.4766 35.3267L38.0547 28.5376C38.1836 28.1079 38.5703 27.8501 39 27.8501C39.4297 27.8501 39.8164 28.1079 39.9883 28.5376Z"
        fill={color}
      />
    </svg>
  );
};
